<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Attire</h1>
      <div class="w-full text-2xl p-4 mt-12 mb-4 bg-theme-pink/25 rounded-md">These shades are just a guide to the theme – no need to match them exactly. Please <b>no</b> pink suits for guys and <b>no</b> white or black dresses for ladies.</div>
      <img src="@/assets/dress-code.png">
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'AttirePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>